module.exports = __webpack_public_path__ + "static/media/ac5.1aa13f23.jpg";